import { render, staticRenderFns } from "./org-config-admin.vue?vue&type=template&id=5cb2d3b4&scoped=true&"
import script from "./org-config-admin.vue?vue&type=script&lang=js&"
export * from "./org-config-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2d3b4",
  null
  
)

export default component.exports